export default __webpack_public_path__ + "static/logo-a59c827b02d20804bc9e86a3a717a5fa.svg";